<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/NE6jVT/tc-custom/9781399018050.jpg?1700302969904" alt="This image is the cover for the book Panzer IV, Medium Tank"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Panzer IV, Medium Tank
      </h1>
      <p class="bookDescription body article font2">
        <b>A fully illustrated guide to Germany’s use of Panzer IV Tanks during the Normandy campaign, perfect for WWII buffs, modelers, and wargamers.</b><br/><br/>When the Allied armies landed on the Normandy beaches on June 6, 1944, they met a reaction force anchored by 758 Pzkpfw IV tanks. The first models of these tanks had entered service in 1937 and the original design remained in use, continually up-gunned and up-armored, throughout the conflict. <br/><br/>Drawing on official documentation and unit histories, Dennis Oliver investigates the formations that operated these deservedly famous vehicles and uses archive photos and extensively researched color illustrations to examine the markings, camouflage, and technical aspects of the Pzkpfw IV tanks that served on the Western Front during the critical summer of 1944. <br/><br/>A key section of this book displays available model kits and aftermarket products, complemented by a gallery of beautifully constructed and painted models in various scales. Technical details as well as modifications introduced during production and in the field are also examined, providing everything the modeler needs to recreate an accurate representation of these historic vehicles.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dennis Oliver
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword Military
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c32ab8f2